const getEnvironment = () => {
  try {
    // Priority order:
    // 1. Explicit REACT_APP_ENV variable
    // 2. Hostname detection (fallback)
    // 3. Default to production
    
    if (process.env.REACT_APP_ENV) {
      return process.env.REACT_APP_ENV;
    }
    
    // Fallback to hostname detection (only if window is available)
    if (typeof window !== 'undefined' && window.location) {
      const hostname = window.location.hostname;
      if (hostname.includes('staging')) {
        return 'staging';
      }
      // Only use development for true localhost, not ngrok tunnels
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'development';
      }
    }
    
    return 'production';
  } catch (error) {
    console.error('Error in getEnvironment:', error);
    return 'production';
  }
};

let environment, config, ENGINE_URL, API_URL, WS_PROTOCOL, getEngineHost;

try {
  environment = getEnvironment();

  config = {
    development: {
      engineUrl: 'http://localhost:8080', // Or your local engine URL
      apiUrl: '', // Uses proxy in development
      wsProtocol: 'ws',
    },
    staging: {
      engineUrl: 'https://staging-ai-twilio.myjava.ai',
      apiUrl: '',
      wsProtocol: 'wss',
    },
    production: {
      engineUrl: 'https://ai-twilio-3ac8.myjava.ai',
      apiUrl: '',
      wsProtocol: 'wss',
    },
  };

  const selectedConfig = config[environment] || config.production;

  ENGINE_URL = selectedConfig.engineUrl;
  API_URL = selectedConfig.apiUrl;
  WS_PROTOCOL = selectedConfig.wsProtocol;

  // Helper function to get engine host without protocol
  getEngineHost = () => {
    return ENGINE_URL.replace(/^https?:\/\//, '');
  };
} catch (error) {
  console.error('Error initializing environment configuration:', error);
  // Fallback to production values
  environment = 'production';
  ENGINE_URL = 'https://ai-twilio-3ac8.myjava.ai';
  API_URL = '';
  WS_PROTOCOL = 'wss';
  getEngineHost = () => 'ai-twilio-3ac8.myjava.ai';
}

export const ENV = environment;
export { ENGINE_URL, API_URL, WS_PROTOCOL, getEngineHost };

export default {
  ENV,
  ENGINE_URL,
  API_URL,
  WS_PROTOCOL,
  getEngineHost,
};